'use client';

import Image from '@/components/Image';

interface BottomBannerProps {
  pageData: any;
}

export default function BottomBanner({ pageData }: BottomBannerProps) {
  const banner4 = pageData?.banner4 || {};

  const isEmpty = (obj: any) => !obj || Object.keys(obj).length === 0;

  if (isEmpty(pageData) || isEmpty(banner4)) return null;

  return (
    <div className="bottom-banner bg-[#0f0f0f] py-[60px] md:py-[80px] xl:py-[107px] pb-[120px] md:pb-[160px] xl:pb-[200px] flex flex-col justify-start items-center">
      <Image
        src={banner4.banner_image}
        alt="Zeelool optical eyeglasses online store8"
        width={750}
        height={400}
        className="banner_image opacity0 w-[400px] md:w-[600px] xl:w-[750px] h-auto"
      />

      <h5
        className="opacity0 w-[300px] md:w-[800px] xl:w-[1400px] font-bb text-center mt-[15px] md:mt-[20px] xl:mt-[26px] mb-[60px] md:mb-[90px] xl:mb-[116px] text-[60px] md:text-[100px] xl:text-[140px] leading-[50px] md:leading-[80px] xl:leading-[110px] text-white"
        dangerouslySetInnerHTML={{ __html: banner4.title }}
      />

      <div className="sub_banners sub_banners1 opacity0 flex flex-col md:flex-row justify-center items-center mb-[40px] md:mb-[60px] xl:mb-[81px]">
        <Image
          src={banner4.banner_image2}
          alt="Zeelool optical eyeglasses online store9"
          width={640}
          height={400}
          className="banner_image2 w-full md:w-[400px] xl:w-[640px] h-auto mb-[20px] md:mb-0 md:mr-[60px] xl:mr-[112px]"
        />
        <div className="right_content flex flex-col justify-center items-start w-full md:w-[500px] xl:w-[700px]">
          <p className="sub_title mb-[20px] md:mb-[30px] xl:mb-[40px] text-[40px] md:text-[55px] xl:text-[70px] font-bb text-white leading-[50px] md:leading-[60px] xl:leading-[70px]">
            {banner4.sub_title1}
          </p>
          <p className="sub_content text-[#a6a6a6] text-[16px] md:text-[20px] xl:text-[26px] leading-[24px] md:leading-[32px] xl:leading-[40px]">
            {banner4.sub_content1}
          </p>
        </div>
      </div>

      <div className="sub_banners sub_banners2 opacity0 flex flex-col md:flex-row justify-center items-center mb-[40px] md:mb-[60px] xl:mb-[81px]">
        <Image
          src={banner4.banner_image3}
          alt="Zeelool optical eyeglasses online store10"
          width={640}
          height={400}
          className="banner_image2 w-full md:w-[400px] xl:w-[640px] h-auto mb-[20px] md:mb-0 md:mr-[60px] xl:mr-[112px]"
        />
        <div className="right_content flex flex-col justify-center items-start w-full md:w-[500px] xl:w-[700px]">
          <p className="sub_title mb-[20px] md:mb-[30px] xl:mb-[40px] text-[40px] md:text-[55px] xl:text-[70px] font-bb text-white leading-[50px] md:leading-[60px] xl:leading-[70px]">
            {banner4.sub_title2}
          </p>
          <p className="sub_content text-[#a6a6a6] text-[16px] md:text-[20px] xl:text-[26px] leading-[24px] md:leading-[32px] xl:leading-[40px]">
            {banner4.sub_content2}
          </p>
        </div>
      </div>

      <div className="sub_banners sub_banners3 opacity0 flex flex-col md:flex-row justify-center items-center">
        <Image
          src={banner4.banner_image4}
          alt="Zeelool optical eyeglasses online store11"
          width={640}
          height={400}
          className="banner_image2 w-full md:w-[400px] xl:w-[640px] h-auto mb-[20px] md:mb-0 md:mr-[60px] xl:mr-[112px]"
        />
        <div className="right_content flex flex-col justify-center items-start w-full md:w-[500px] xl:w-[700px]">
          <p className="sub_title mb-[20px] md:mb-[30px] xl:mb-[40px] text-[40px] md:text-[55px] xl:text-[70px] font-bb text-white leading-[50px] md:leading-[60px] xl:leading-[70px]">
            {banner4.sub_title3}
          </p>
          <p className="sub_content text-[#a6a6a6] text-[16px] md:text-[20px] xl:text-[26px] leading-[24px] md:leading-[32px] xl:leading-[40px]">
            {banner4.sub_content3}
          </p>
        </div>
      </div>
    </div>
  );
}
